import { CloseIcon, IconSize } from "@shared/components/ui/Icon";

interface ModalBlankProps {
  id: string;
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  showCloseButton?: boolean;
  className?: string;
  children: React.ReactNode;
}

function ModalBlank({
  id,
  modalOpen,
  setModalOpen,
  showCloseButton = false,
  className,
  children,
}: ModalBlankProps) {
  return (
    <>
      {/* Modal backdrop */}
      {modalOpen && (
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-30 z-50 transition-opacity"
          aria-hidden="true"
          onClick={() => setModalOpen(false)}
        ></div>
      )}

      {/* Modal dialog */}
      {modalOpen && (
        <div
          id={id}
          className="fixed inset-0 z-50 overflow-hidden flex items-center justify-center px-4 sm:px-6"
          role="dialog"
          aria-modal="true"
        >
          <div
            className={`bg-white dark:bg-gray-800 rounded shadow-lg max-w-lg w-full max-h-full ${className} ${
              showCloseButton ? "relative" : ""
            }`}
          >
            {showCloseButton && (
              <div className="absolute top-4 right-4 z-50">
                <button
                  onClick={() => setModalOpen(false)}
                  className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                >
                  <CloseIcon size={IconSize.SMALL} />
                </button>
              </div>
            )}
            {children}
          </div>
        </div>
      )}
    </>
  );
}

export default ModalBlank;
